import { RefObject } from 'react';

export const isInViewport = (ele: RefObject<HTMLDivElement>, offset = 0): boolean => {
  if (!ele || !ele.current) {
    return null;
  }
  const top = ele.current.getBoundingClientRect().top;
  return top + offset >= 0 && top - offset <= window.innerHeight;
};

export default isInViewport;
